import React, { Component } from 'react';
import {withRouter} from 'react-router';
import * as Elements from '../elements/body/index';
import * as DecoratedComponents from '../components/HOC/HOCDecoratedComponents';
import * as styles from './componentStyles';
import ProfileCompletionSection from './ProfileCompletionSection';
import Anchor from "../../../../dashboardNew/objects/Anchor";

class ProfileBody extends Component {

    render() {
        const { summary, experience, education, certificates, endorsements, expertiseData, ui, investments, profileComplete } = this.props;
        return (
            <main className="user-content">
                {
                    !ui.guestMode &&
                    <ProfileCompletionSection profileComplete={profileComplete} />
                }

                {ui.guestMode ? null :
                    <div className="container has-padding-0">
                        <div className="row">
                            <div className="col-12">
                                <p className="body-copy theme-site-helper">
                                    Set job alert and member search preferences,
                                    <Anchor internal path={`/account/jobs-and-member-preferences`} anchorClass={'clickable'}>
                                        Click here
                                    </Anchor>
                                    .
                                </p>
                            </div>
                        </div>
                    </div>
                }

                <Elements.PublishAndPreview
                    {...this.props} />
                <DecoratedComponents.Summary
                    componentData={summary}
                    {...ui}
                    actionName="summaryApiCall"
                    styles={styles.summary}
                    summaryToggle />
                <DecoratedComponents.ExperienceHOCWithList
                    {...ui}
                    actionName="experienceApiCall"
                    data={Object.assign({}, experience, expertiseData, { styles: styles.experience })} />
                <DecoratedComponents.Endorsements
                    id="endorsements"
                    componentData={endorsements}
                    actionName="requestEndorsement"
                    styles={styles.endorsements}
                    {...ui} />
                <DecoratedComponents.EducationHOCWithList
                    {...ui}
                    actionName="educationApiCall"
                    data={Object.assign({}, education, { styles: styles.education })} />
                <DecoratedComponents.CertificateHOCWithList
                    {...ui}
                    actionName="certificatesApiCall"
                    data={Object.assign({}, certificates, { styles: styles.certificates })} />
                <Elements.Achievements
                    {...this.props} />
                <Elements.Investments {...ui} {...investments} />
            </main>
        )
    }
};


export default withRouter(ProfileBody);




























// WEBPACK FOOTER //
// src/client/components/site/features/profile/components/ProfileBody.js